import { useShoppingCart } from 'src/app/shared/hooks/useShoppingCart';
import { PremiumUpsell } from 'src/app/v2/components/PremiumUpsell';
import { useGetOrderSummary } from 'src/app/v2/hooks/useGetOrderSummary';
import { useHirerAccount } from 'src/app/v2/hooks/useHirerAccount';
import {
  findUpsellProduct,
  shouldShowPremiumUpsell,
  type PremiumUpsellType,
} from 'src/app/v2/utils/getShouldShowPremiumUpsell';
import type { CreateJobMutation } from 'src/graphql/generated';

interface UpsellSectionProps {
  job: NonNullable<CreateJobMutation['createJob']>;
}

export const PremiumUpsellSection: React.FC<UpsellSectionProps> = ({ job }) => {
  const { cartState, orderState } = useShoppingCart(); // orderstate
  const hirerAccount = useHirerAccount();
  const orderId = orderState?.order?.orderId;
  const orderSummary = useGetOrderSummary(orderId, hirerAccount?.nation);

  const upsellProduct = findUpsellProduct(cartState);
  if (!upsellProduct) {
    return null;
  }

  const shouldShowUpsell: PremiumUpsellType | undefined =
    shouldShowPremiumUpsell({
      job,
      hirerAccount,
      orderSummary,
      upsellProduct,
    });
  if (!shouldShowUpsell) {
    return null;
  }

  return (
    <PremiumUpsell
      job={job}
      sessionStorageKey={upsellProduct.sessionStorageKey}
      baseProductId={upsellProduct.baseProductId}
      upsellProductId={upsellProduct.upsellProductId}
    />
  );
};
